import styled from "styled-components";

export const PaginationWrapper = styled.div`
  justify-content: center;
  display: flex;
`;

export const PageNumber = styled.div`
  /* border: 1px solid black; */
  width: 18px;
  height: 18px;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 5px;
  background-color: ${props =>
    props.isCurrentPage === true ? "#eee" : "inherit"};
  padding: 2px;
  font-weight: bold;
  font-size: 12px;
  display: flex;
  justify-content : center;
  align-items : center;
  cursor : pointer;
`;

const PageButtonContainer = styled.div`
  display: flex;
  align-items: center;
  height: 18px;
  padding: 2px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
  background-color: #424242;
  font-size: 12px;
  font-weight: 600;
  visibility: ${props => (props.isHidden ? "hidden" : "visible")};
  cursor : pointer;
  /* border: 1px solid black; */
`;

export const PreviousPageButtonContainer = styled(PageButtonContainer)`
  margin-right: 5px;
`;

export const NextPageButtonContainer = styled(PageButtonContainer)`
  margin-left: 5px;
`;

export const PrePageButtonIconDouble = styled.img`
  width: 15px;
  height: 15px;
  transform : rotate(180deg);
  margin-left: -5  px;
`;

export const PrePageButtonIcon = styled.img`
  width: 15px;
  height: 15px;
  transform : rotate(180deg);
  margin-left: -10px;
`;

export const PageButtonIconDouble = styled.img`
  width: 15px;
  height: 15px;
  margin-right: -5px;
`;

export const PageButtonIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-right: -10px;
`;

export const PreviousPageText = styled.div`
  color: white;
  /* margin-left: 8px; */
  width: 100%;
`;
export const NextPageText = styled.div`
  color: white;
   /* margin-left: 8px; */
   width: 100%;
`;
